import { Components } from "appworks/components/components";
import { gameLoop } from "appworks/core/game-loop";
import { animationManager } from "appworks/graphics/animation/animation-manager";
import { canvasManager } from "appworks/graphics/canvas/canvas-manager";
import { graphicsManager } from "appworks/graphics/graphics-manager";
import { Layers } from "appworks/graphics/layers/layers";
import { gameState } from "appworks/model/game-state";
import { builderManager } from "appworks/server/builders/builder-manager";
import { Services } from "appworks/services/services";
import { stateMachine } from "appworks/state-machine/state-machine";
import { uiFlags } from "appworks/ui/flags/ui-flags";
import { gameLayers } from "game-layers";
import { partnerConnectForceLoader } from "partner-connect/debug/menu/partner-connect-force-loader";
import { PartnerConnectEvents } from "partner-connect/partner-connect-events";
import { PartnerConnect, PartnerConnectManager } from "partner-connect/partner-connect-manager";
import { partnerConnectConnector } from "partner-connect/server/connectors/partner-connect-connector";
import { DebugMenu } from "slotworks/debug/menu/debug-menu";
import { slotDefinition } from "slotworks/model/slot-definition";

declare var window: any;

export function TGRSetupDebug() {

    window.gameLoop = gameLoop;
    window.states = stateMachine;
    window.layers = Layers;
    window.components = Components;
    window.gamestate = gameState;
    window.builderManager = builderManager;
    window.canvasManager = canvasManager;
    window.services = Services;
    window.graphicsManager = graphicsManager;
    window.gameLayers = gameLayers;
    window.slotDefinition = slotDefinition;
    window.animationManager = animationManager;
    window.uiFlags = uiFlags;
    window.debugMenu = DebugMenu;

    window.pc = PartnerConnect;
    window.pcc = partnerConnectConnector;
    window.pcm = PartnerConnectManager;
    window.pce = PartnerConnectEvents;

    partnerConnectForceLoader.setPartnerConnectForceData({
        // "[BG] < Stake"                : "baseLessStake",
        // "[BG] = Stake"                : "baseStake",
        // "[FS] < Stake"                : "freespinsLessStake",
        // "[FS] = Stake"                : "freespinsStake",
        "[FS] No Wins"                : "freespins",
        "[FS] & Wins"                 : "freeSpinsWin",
        "[FS] & Quickhit"             : "freeSpinsQuickhit",
        "[FS] Rettriger First"        : "freeSpinsRettrigerFirst",
        "[FS] Rettriger Last"         : "freeSpinsRettrigerLast",
        "[FS] Rettriger Middle"       : "freeSpinsRettrigerMiddle",
        "[FS] Retrigger First & QH"   : "freeSpinsRetriggerFirstAndQuickhit",
        "[QH] No Collect"             : "quickhitNoCollect",
        "[QH] Collect & FS"           : "quickhitAndFreeSpin",
        "[QH] Collect"                : "quickhitCollect",
        "[QH] Collect & Line"         : "quickhitCollectAndLine",
        "[QH] Collect MINOR"          : "quickhitCollectMinor",
        "[QH] Collect MAJOR"          : "quickhitCollectMajor",
        "[QH] Collect MINI"           : "quickhitCollectMini",
        "[QH] Collect GRAND"          : "quickhitCollectGrand",
        "[QH] Collect GRAND & MINI"   : "quickhitCollectGrandAndMini",
        "[QH] Collect GRAND & Line"   : "quickhitCollectGrandAndLine"
    });
    partnerConnectForceLoader.populateForceMenu();
}
